import { create } from "zustand"

const useToggleStoreBase = create((set) => ({
  states: {},

  open: (key) =>
    set((state) => ({
      states: {
        ...state.states,
        [key]: true
      }
    })),

  close: (key) =>
    set((state) => ({
      states: {
        ...state.states,
        [key]: false
      }
    })),

  toggle: (key) =>
    set((state) => ({
      states: {
        ...state.states,
        [key]: !state.states[key]
      }
    }))
}))

export const useToggleStore = (id) => {
  const show = useToggleStoreBase((state) => !!state.states[id])
  const open = useToggleStoreBase((state) => state.open)
  const close = useToggleStoreBase((state) => state.close)
  const toggle = useToggleStoreBase((state) => state.toggle)

  if (!id) {
    console.error("ID가 존재하지 않음.")
    return {
      show: false,
      open: () => {},
      close: () => {},
      toggle: () => {}
    }
  }

  return {
    show,
    open: () => open(id),
    close: () => close(id),
    toggle: () => toggle(id)
  }
}
